import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   title: "",
   author: "",
   isFavorit: false,
};

const filterSlice = createSlice({
   name: "filter",
   initialState: initialState,
   reducers: {
      setTitleFilter: (state, action) => {
         state.title = action.payload;
      },
      setAuthorFilter: (state, action) => {
         state.author = action.payload;
      },
      setIsFavoritFilter: (state) => {
         state.isFavorit = !state.isFavorit;
      },
      resetFilters: () => {
         return initialState;
      },
   },
});

export const {
   setAuthorFilter,
   setTitleFilter,
   resetFilters,
   setIsFavoritFilter,
} = filterSlice.actions;

export const selectTitleFilter = (state) => state.filter.title;
export const selectAuthorFilter = (state) => state.filter.author;
export const selectIsFavoritFilter = (state) => state.filter.isFavorit;

// export const selectFilters = (state) => state.filters;
export default filterSlice.reducer;
